import axios from "axios";
import { numberData } from "./numberData";
import config from "../../config";
import { headers_get } from "../tokens/get_headers_user";

export async function pagination_method(origen, params, enablePagination = true) {
  const headers = await headers_get();

  const URL_MAPPINGS = {
    bp: {
      url: `${config?.URL_BUSINESS_PARTNERS}/od/business-partners?role=FACTURA&`,
      urlnumber: `${config?.URL_BUSINESS_PARTNERS}/od/business-partners/number`,
    },
    cabinets: {
      url: `${config?.URL_ASSETS}/od/cabinets?`,
      urlnumber: `${config?.URL_ASSETS}/od/cabinets/number?`,
    },
    invoices: {
      url: `${config?.URL_INVOICES}/od/invoices?count=false&`,
      urlenablePagination: `${config?.URL_INVOICES}/od/invoices?count=false`,
      urlnumber: `${config?.URL_INVOICES}/od/invoices?count=true`,
    },
  };

  const { url = config?.URL_BUSINESS_PARTNERS, urlnumber = "", urlenablePagination = "" } = URL_MAPPINGS[origen] || {};


  if (enablePagination) {

    try {
      const totalData = await numberData(urlnumber, params);
      if (!totalData) return [];

      if (totalData <= 1000) {
        const { data } = await axios.get(`${url}offset=0&limit=${totalData}`, { params: params, headers });
        return data || [];
      }

      const pageSize = 1000;
      const numRequests = Math.ceil(totalData / pageSize);

      console.log(numRequests)
      const baseIncrement = Math.ceil(totalData / numRequests); // Cada incremento de límite
      let offset = 0;
      const promises = [];

      for (let i = 0; i < numRequests; i++) {
        const limit = baseIncrement * (i + 1); // Cada límite es acumulativo

        const requestUrl = `${url}offset=${offset}&limit=${limit}`;
        promises.push(axios.get(requestUrl, { params, headers }).then(response => response.data || []));
        offset += baseIncrement; // El offset incrementa por la base cada vez
      }

      const results = await Promise.all(promises);
      return results.flat();
    } catch (error) {
      console.error("Error in pagination_method:", error);
      return [];
    }
  } else {
    try {
      const { data } = await axios.get(`${urlenablePagination}`, { params: params, headers });
      return data || [];
    } catch (error) {
      console.error("Error in pagination_method:", error);
      return [];
    }
  }
}
